<template>
    <transition name="fade" mode="out-in">
        <card>
            hepp
        </card>
    </transition>
</template>
<script>
export default {
    name : "CategoryModal",

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/CategoryModal.vue